import { Action } from 'redux';

import { FetchRecommendationsSucceeded } from '../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../bootstrap/redux/actions/isActionFactory';
import { ListResult } from '../../httpClient/fetchers/ListResult';
import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';

export interface FetchRecommendationsSucceededAction extends Action {
  readonly result: ListResult<IContentInfo>;
}

export function getFetchRecommendationsSucceededAction(result: ListResult<IContentInfo>): FetchRecommendationsSucceededAction {
  return {
    type: FetchRecommendationsSucceeded,
    result
  };
}

export const isFetchRecommendationsSucceededAction = isActionFactory<FetchRecommendationsSucceededAction>(FetchRecommendationsSucceeded);

